<rt-input
  [value]="value"
  [displayedValue]="displayLocaleFormatting() ? displayedValue : null"
  [placeholder]="placeholder()"
  [disabled]="disabled"
  [readOnly]="readOnly()"
  [invalid]="getInvalidValue()"
  [disableInvalidStyles]="disableInvalidStyles()"
  (blur)="blur.emit($event)"
  (valueChange)="handleChange($event)"
  (focus)="onFocus()"
/>
